import { Button, UploadFileIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import type { PropsWithChildren } from '@shared/utils';

import { QContentImportModal } from '../qcontent-import-modal';

interface QContentImportButtonProps extends PropsWithChildren {
  singleImportTemplateUrl: string;
  itemSetImportTemplateUrl: string;
}

export default function QContentImportButton(props: Readonly<QContentImportButtonProps>) {
  const { singleImportTemplateUrl, itemSetImportTemplateUrl, children } = props;
  const [isImportModalOpen, importModalHandlers] = useDisclosure();
  const { open: openImportModal, close: closeImportModal } = importModalHandlers;

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        startIcon={<UploadFileIcon />}
        onClick={openImportModal}
      >
        {children}
      </Button>
      <QContentImportModal
        open={isImportModalOpen}
        onClose={closeImportModal}
        singleImportTemplateUrl={singleImportTemplateUrl}
        itemSetImportTemplateUrl={itemSetImportTemplateUrl}
      />
    </>
  );
}
